import { useState } from "react";
import { supabase } from "../supabaseClient";

export function useLearningExercises(session) {
  const [submittingLearningExercise, setSubmittingLearningExercise] =
    useState(false);

  const submitLearningExercise = async ({
    exerciseId,
    answer,
    isCorrect,
  }) => {
    if (!session?.user?.id) {
      alert("Please log in first.");
      return false;
    }

    if (!exerciseId) {
      alert("Missing exercise id.");
      return false;
    }

    setSubmittingLearningExercise(true);

    const { error } = await supabase
      .from("learning_exercise_attempts")
      .insert({
        user_id: session.user.id,
        exercise_id: exerciseId,
        answer,
        is_correct: isCorrect,
        attempted_at: new Date().toISOString(),
      });

    if (error) {
      console.error("LEARNING EXERCISE ATTEMPT ERROR:", error);
      alert(error.message);
      setSubmittingLearningExercise(false);
      return false;
    }

    setSubmittingLearningExercise(false);
    return true;
  };

  return {
    submittingLearningExercise,
    submitLearningExercise,
  };
}